import { Box, Divider, Grid, MenuItem, Typography } from '@mui/material';
import _ from 'lodash';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
/** API */
/** COMPONENT */
/** STYLE */
import InputCheckbox from 'component/Input/InputCheckbox';
import BasicSelect from 'component/Select/BasicSelect';
import TableCustom from 'component/Table/TableCustom';
import TableRowCommon from 'component/Table/TableRowCommon';
import { colors } from 'constants/theme';
import moment from 'moment';
import RadioButton from 'new-components/buttons/radio-button';
import DateInput from 'new-components/inputs/date-input';

export interface ApplicationInterface {
  package: "STANDARD" | "PREMIUM" | "ULTRA"
  enableApp: string
  patientAppointmentApp: string,
  branchDefaultRegisterApps: any[]
  callbackEnableApp: (value: any) => void
  callbackPatientAppointmentApp: (value: any) => void
  callbackRegisterApps: (value: any) => void
  useWeb: string
  callbackUseWeb: (value: string) => void
  dataABout: any
  setDataAbout: (value: any) => void
  errorMessageSetting: any
  errorMessageSettingCrm: any
  errorMessageSettingNHSO: any
  callBackCrm: (value: any) => void
  callBackNHSO: (value: any) => void
  submit: boolean
  loading: boolean
}

export default function FormApplication(props: ApplicationInterface) {
  const { t, i18n } = useTranslation()
  const [enableApp, setEnableApp]: any = useState(props.enableApp);
  const [usePackage, setPackage] = useState(props.package);
  const [branchDefaultRegisterApps, setBranchDefaultRegisterApps] = useState(props.branchDefaultRegisterApps);
  const [page, setPage] = useState(1)
  const [pageLimit, setPageLimit] = useState(10)
  const [rowCount, setRowCount] = useState(0)
  const [dateExpiredWeb, setDateExpiredWeb] = useState('')
  const [dateExpiredCrm, setDateExpiredCrm] = useState('')
  const [allBranchesCrm, setAllBranchesCrm] = useState('0')
  const [isChecksCrm, setIsChecksCrm] = useState([] as any)
  const [isCheckAllCrm, setIsCheckAllCrm] = useState('')
  const [dateExpiredNHSO, setDateExpiredNHSO] = useState('')
  const [allBranchesNHSO, setAllBranchesNHSO] = useState('0')
  const [isChecksNHSO, setIsChecksNHSO] = useState([] as any)
  const [erroeCrm, setErrorCrm] = useState([] as any)
  const [erroeNHSO, setErrorNHSO] = useState([] as any)
  const [isCheckAllNHSO, setIsCheckAllNHSO] = useState('')
  const inited = useRef(false);

  useEffect(() => {
    if (!inited.current && props.branchDefaultRegisterApps) {
      inited.current = true;
      const branches = props.branchDefaultRegisterApps;
      setBranchDefaultRegisterApps(_.cloneDeep(branches));
      setIsChecksCrm(branches.filter(i => i.isUseCrm === '1').map(i => Number(i.branchId)));
      setIsChecksNHSO(branches.filter(i => i.isUseNHSO === '1').map(i => Number(i.branchId)));
    }
    setErrorCrm(props.errorMessageSettingCrm);
    setErrorNHSO(props.errorMessageSettingNHSO);
  }, [props.branchDefaultRegisterApps, props.errorMessageSettingCrm, props.errorMessageSettingNHSO]);


  useEffect(() => { setEnableApp(props.enableApp) }, [props.enableApp]);
  useEffect(() => { setPackage(props.package) }, [props.package]);
  useEffect(() => { setDateExpiredWeb(props.dataABout?.dateExpiredWeb) }, [props.dataABout?.dateExpiredWeb]);


  useEffect(() => {
    setAllBranchesCrm(props.dataABout?.useAllBranchesCrm);
    setDateExpiredCrm(props.dataABout?.dateExpiredAllBranchCrm);
    if (props.dataABout?.useAllBranchesCrm === '1' && !props.loading) {
      setIsChecksCrm(props.branchDefaultRegisterApps.map((e: any) => e.branchId));
    }
    if (props.dataABout?.useAllBranchesNHSO === '1' && !props.loading) {
      setIsChecksNHSO(props.branchDefaultRegisterApps.map((e: any) => e.branchId));
    }
  }, [props.dataABout?.useAllBranchesCrm, props.dataABout?.dateExpiredAllBranchCrm, props.loading]);

  useEffect(() => {
    setAllBranchesNHSO(props.dataABout?.useAllBranchesNHSO);
    setDateExpiredNHSO(props.dataABout?.dateExpiredAllBranchNHSO);
  }, [props.dataABout?.useAllBranchesNHSO, props.dataABout?.dateExpiredAllBranchNHSO]);

  useEffect(() => {
    handleOnCheckAllCrm();
    handleOnCheckAllNHSO();
    props?.callBackCrm(isChecksCrm);
    props?.callBackNHSO(isChecksNHSO);
    setErrorCrm(props.errorMessageSettingCrm);
    setErrorNHSO(props.errorMessageSettingNHSO);
  }, [isChecksCrm, isChecksNHSO, branchDefaultRegisterApps, props.submit]);

  const handleOnCheckAllCrm = () => {
    const hasAll = _.every(branchDefaultRegisterApps, (i: any) => _.some(isChecksCrm, (j: number) => Number(i.branchId) === Number(j)));
    setIsCheckAllCrm(_.isEmpty(isChecksCrm) ? '' : hasAll ? 'checked' : 'indeterminate');
  };

  const handleOnCheckAllNHSO = () => {
    const hasAll = _.every(branchDefaultRegisterApps, (i: any) => _.some(isChecksNHSO, (j: number) => Number(i.branchId) === Number(j)));
    setIsCheckAllNHSO(_.isEmpty(isChecksNHSO) ? '' : hasAll ? 'checked' : 'indeterminate');
  };

  const onCheckAllCrm = async (event?: any) => {
    const { checked } = event;
    const ids = branchDefaultRegisterApps.map(item => item.branchId).filter(id => id != null).map(Number);

    if (!checked) {
      const updated = branchDefaultRegisterApps.map(b => ({
        ...b,
        isUseCrm: '0',
        dateExpiredCrm: null
      }));
      setBranchDefaultRegisterApps(updated);
      props.callbackRegisterApps(updated);
      setIsChecksCrm([]);
    } else {
      const updated = branchDefaultRegisterApps.map(b => ({
        ...b,
        isUseCrm: '1',
        dateExpiredCrm: b.dateExpiredCrm || null
      }));
      setBranchDefaultRegisterApps(updated);
      props.callbackRegisterApps(updated);
      setIsChecksCrm(ids);
    }
  };


  const onCheckAllNHSO = async (event?: any) => {
    const { checked } = event;
    const ids = branchDefaultRegisterApps.map(item => item.branchId).filter(id => id != null).map(Number);

    if (!checked) {
      const updated = branchDefaultRegisterApps.map(b => ({
        ...b,
        isUseNHSO: '0',
        dateExpiredNHSO: null
      }));
      setBranchDefaultRegisterApps(updated);
      props.callbackRegisterApps(updated);
      setIsChecksNHSO([]);
    } else {
      const updated = branchDefaultRegisterApps.map(b => ({
        ...b,
        isUseNHSO: '1',
        dateExpiredNHSO: b.dateExpiredNHSO || null
      }));
      setBranchDefaultRegisterApps(updated);
      props.callbackRegisterApps(updated);
      setIsChecksNHSO(ids);
    }
  };

  const onCheck = (event: any, type: 'Crm' | 'NHSO') => {
    const { checked, value } = event;
    const branchId = Number(value);
    if (checked) {
      if (type === 'Crm') setIsChecksCrm((prev: any) => [...prev, branchId]);
      else setIsChecksNHSO((prev: any) => [...prev, branchId]);
    } else {
      if (type === 'Crm') {
        setIsChecksCrm((prev: any) => prev.filter((id: any) => id !== branchId));
        handleClearBranchDateAll(branchId, type);
      } else {
        setIsChecksNHSO((prev: any) => prev.filter((id: any) => id !== branchId));
        handleClearBranchDateAll(branchId, type);
      }
    }
  };


  const generateHeadCells = (type: 'Crm' | 'NHSO') => {
    const isCheckAllState = type === 'Crm' ? isCheckAllCrm : isCheckAllNHSO;
    const onCheckAllHandler = type === 'Crm' ? onCheckAllCrm : onCheckAllNHSO;
    const hasEligibleBranches = _.some(branchDefaultRegisterApps, b => b[`isUse${type}`] !== '0');
    return [
      {
        id: 'branchId',
        disablePadding: false,
        label: 'CHECKBOX',
        isCheckbox: true,
        indeterminate: isCheckAllState === 'indeterminate',
        checked: isCheckAllState === 'checked',
        disabled: !hasEligibleBranches,
        disableDropdown: true,
        values: [],
        onCheckAll: (event: any) => onCheckAllHandler(event.target as HTMLInputElement),
        width: '70px'
      },
      { id: 'no', disablePadding: false, label: t('CLINIC_MANAGEMENT.SELECT_RADIO.TABLE.INDEX'), width: '60px' },
      { id: 'id', disablePadding: false, label: t('CLINIC_MANAGEMENT.SELECT_RADIO.TABLE.BRANCH'), width: '200px' },
      { id: 'dateExpired', disablePadding: false, label: t('CLINIC_MANAGEMENT.SELECT_RADIO.TABLE.DATE_EXPIRED') },
    ];
  };

  const handleBranchDateChange = (branchId: number, newDate: string | null | Date, type: 'Crm' | 'NHSO') => {
    const formattedDate = newDate ? moment(newDate).format('YYYY-MM-DD') : null;
    const updatedBranches = branchDefaultRegisterApps.map(branch => {
      if (Number(branch.branchId) === branchId) {
        return {
          ...branch,
          [`isUse${type}`]: '1',
          [`dateExpired${type}`]: formattedDate
        };
      }
      return branch;
    });
    setBranchDefaultRegisterApps(updatedBranches);
    props.callbackRegisterApps(updatedBranches);
  };

  const handleClearBranchDateAll = (branchId: number, type: 'Crm' | 'NHSO') => {
    const updatedBranches = branchDefaultRegisterApps.map(branch => {
      if (Number(branch.branchId) === branchId) {
        return { ...branch, [`isUse${type}`]: '0', [`dateExpired${type}`]: null };
      }
      return branch;
    });
    setBranchDefaultRegisterApps(updatedBranches);
    props.callbackRegisterApps(updatedBranches);
  };

  const renderData = (objData: any, index: number, type: 'Crm' | 'NHSO', errorMessage: any) => {
    index = page * pageLimit - pageLimit + index + 1
    const { branchId, branchName, branchNameEn } = objData
    const rowCheck = _.some(type === 'Crm' ? isChecksCrm : isChecksNHSO, (id: number) => id === Number(branchId));
    const objRenderData = {
      key: `${type}-${branchId}`,
      id: branchId,
      obj: objData,
      rowSelect: rowCheck,
      columns: [
        { option: 'CHECKBOX', align: 'center', label: branchId },
        { option: 'TEXT', align: 'center', label: index },
        { option: 'TEXT', align: 'left', label: branchName ?? branchNameEn },
        {
          option: 'COMPONENT',
          align: 'left',
          component:
            <Box display="flex" justifyContent="flex-start" alignItems="center">
              <DateInput
                required
                label={t('CLINIC_MANAGEMENT.SELECT_RADIO.TABLE.DATE_EXPIRED')}
                onChange={(e) => handleBranchDateChange(branchId, e, type)}
                value={!rowCheck ? '' : objData[`dateExpired${type}`]}
                width={300}
                onClear={(e) => {
                  e.stopPropagation()
                  handleClearBranchDateAll(branchId, type)
                }}
                helperText={!rowCheck ? '' : objData[`dateExpired${type}`] ? '' : t(errorMessage)}
                disabled={!rowCheck}
                disabledDatePast
                language={i18n.language.toUpperCase() as any}
              />
            </Box>
        }
      ]
    }
    return (
      <TableRowCommon {...objRenderData} onCheck={(e) => onCheck(e.target, type)} />
    )
  }

  return (
    <Box className="px-4 py-2">
      <Typography className='mb-2' sx={{ fontWeight: 500, fontSize: '18px' }}>{t('CLINIC_MANAGEMENT.LABEL.ACTIVATION')}</Typography>
      <Box>
        <Box marginX={'10px'}>
          <InputCheckbox
            disabled={props.package === 'STANDARD'}
            label={t('CLINIC_MANAGEMENT.LABEL.APPLICATION')}
            checked={enableApp === '1'}
            onChange={() => props.callbackEnableApp(enableApp === '1' ? '0' : '1')}
          /></Box>
        <Box marginX={'30px'}>
          <InputCheckbox
            disabled={props.package !== 'ULTRA'}
            label={t('CLINIC_MANAGEMENT.FORM.FUNCTION_APPOINTMENT_APPLICATION')}
            checked={enableApp === '1' ? props.dataABout?.patientAppointmentApp === '1' : false}
            onChange={() => props.setDataAbout((value: any) => ({ ...value, patientAppointmentApp: props.dataABout?.patientAppointmentApp === '1' ? '0' : '1' }))} />
        </Box>
      </Box>
      <Box>
        <Box marginX={'10px'} >
          <InputCheckbox
            label={t('CLINIC_MANAGEMENT.FORM.WEBSITE_ENABLE')}
            checked={props.dataABout?.useWeb === '1'}
            onChange={() => props.setDataAbout((value: any) => ({ ...value, useWeb: props.dataABout?.useWeb === '1' ? '0' : '1' }))} />
        </Box>
        {props.dataABout?.useWeb === '1' && <Box paddingLeft={'32px'} paddingY={'10px'}>
          <DateInput
            required
            label={t('CLINIC_MANAGEMENT.SELECT_RADIO.TABLE.DATE_EXPIRED')}
            onChange={(e) => {
              setDateExpiredWeb(moment(e).format('YYYY-MM-DD'))
              props.setDataAbout((value: any) => ({ ...value, dateExpiredWeb: moment(e).format('YYYY-MM-DD') }))
            }}
            value={dateExpiredWeb}
            width={456}
            onClear={(e) => {
              e.stopPropagation()
              setDateExpiredWeb('')
              props.setDataAbout((value: any) => ({ ...value, dateExpiredWeb: '' }))
            }}
            helperText={dateExpiredWeb ? '' : t(props.errorMessageSetting.DATE_EXPIRED_WEB)}
            disabledDatePast
            language={i18n.language.toUpperCase() as any}
          />
        </Box>}
      </Box>
      <Box >
        <Box marginX={'10px'}>
          <InputCheckbox
            label={t('CLINIC_MANAGEMENT.FORM.CRM_ENABLE')}
            checked={props.dataABout?.useCrm === '1'}
            onChange={() => props.setDataAbout((value: any) => ({ ...value, useCrm: props.dataABout?.useCrm === '1' ? '0' : '1' }))} />
          {props.dataABout?.useCrm === '1' && <>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Box paddingLeft={'32px'} display="flex" justifyContent="flex-start" alignItems="center">
                  <RadioButton
                    name="radio-buttons-group"
                    onChange={(e) => {
                      setAllBranchesCrm(e.target.value)
                      props.setDataAbout((value: any) => ({ ...value, useAllBranchesCrm: e.target.value }))
                    }}
                    sx={{ gap: '0px' }}
                    defaultValue={props.dataABout?.useAllBranchesCrm}
                    value={allBranchesCrm}
                    options={[
                      { label: t('CLINIC_MANAGEMENT.SELECT_RADIO.BRANCH_ALL'), value: '1', },
                      { label: t('CLINIC_MANAGEMENT.SELECT_RADIO.BRANCH_SPLIT'), value: '0', },
                    ]}
                  />
                </Box>
              </Grid>
              {props.dataABout?.useAllBranchesCrm === '1' && <Grid item xs={12} sm={6}>
                <Box display="flex" justifyContent="flex-start" alignItems="center">
                  <DateInput
                    required
                    label={t('CLINIC_MANAGEMENT.SELECT_RADIO.TABLE.DATE_EXPIRED')}
                    onChange={(e) => {
                      setDateExpiredCrm(moment(e).format('YYYY-MM-DD'))
                      props.setDataAbout((value: any) => ({ ...value, dateExpiredAllBranchCrm: moment(e).format('YYYY-MM-DD') }))
                    }}
                    value={dateExpiredCrm}
                    width={456}
                    onClear={(e) => {
                      e.stopPropagation()
                      setDateExpiredCrm('')
                      props.setDataAbout((value: any) => ({ ...value, dateExpiredAllBranchCrm: '' }))
                    }}
                    helperText={dateExpiredCrm ? '' : t(props.errorMessageSetting.DATE_EXPIRED_CRM)}
                    //  disabled={voucherId !== 0}
                    disabledDatePast
                    language={i18n.language.toUpperCase() as any}
                  />
                </Box>
              </Grid>}
            </Grid>
            {props.dataABout?.useAllBranchesCrm === '0' && <Box marginTop="16px" paddingLeft="32px">
              <TableCustom
                headCells={generateHeadCells('Crm')}
                onSort={(sortByVal: string, sortTypeVal: string) => {
                  // setSortByVal(sortByVal)
                  // setSortTypeVal(sortTypeVal)
                }}
                page={page}
                pageLimit={pageLimit}
                rowsData={props?.branchDefaultRegisterApps?.map((item: any, index: number) => {
                  return renderData(item, index, 'Crm', erroeCrm[index]?.DATE_EXPIRED)
                })}
                setPage={(e) => setPage(e)}
                setPageLimit={(e) => setPageLimit(e)}
                sortBy={'branchId'}
                sortType={'ASC'}
                rowCount={rowCount}
                hidePagination={true}
              />
            </Box>}
          </>}
        </Box>
      </Box>
      <Box>
        <Box marginX={'10px'}>
          <InputCheckbox
            label={t('CLINIC_MANAGEMENT.FORM.NHSO_ENABLE')}
            checked={props.dataABout?.useNHSO === '1'}
            onChange={() => props.setDataAbout((value: any) => ({ ...value, useNHSO: props.dataABout?.useNHSO === '1' ? '0' : '1' }))} />
          {props.dataABout?.useNHSO === '1' && <>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Box paddingLeft={'32px'} display="flex" justifyContent="flex-start" alignItems="center">
                  <RadioButton
                    name="radio-buttons-group"
                    onChange={(e) => {
                      setAllBranchesNHSO(e.target.value)
                      props.setDataAbout((value: any) => ({ ...value, useAllBranchesNHSO: e.target.value }))
                    }}
                    sx={{ gap: '0px' }}
                    defaultValue={props.dataABout?.useAllBranchesNHSO}
                    value={allBranchesNHSO}
                    options={[
                      { label: t('CLINIC_MANAGEMENT.SELECT_RADIO.BRANCH_ALL'), value: '1', },
                      { label: t('CLINIC_MANAGEMENT.SELECT_RADIO.BRANCH_SPLIT'), value: '0', },
                    ]}
                  />
                </Box>
              </Grid>
              {props.dataABout?.useAllBranchesNHSO === '1' && <Grid item xs={12} sm={6}>
                <Box display="flex" justifyContent="flex-start" alignItems="center">
                  <DateInput
                    required
                    label={t('CLINIC_MANAGEMENT.SELECT_RADIO.TABLE.DATE_EXPIRED')}
                    onChange={(e) => {
                      setDateExpiredNHSO(moment(e).format('YYYY-MM-DD'))
                      props.setDataAbout((value: any) => ({ ...value, dateExpiredAllBranchNHSO: moment(e).format('YYYY-MM-DD') }))
                    }}
                    value={dateExpiredNHSO}
                    width={456}
                    onClear={(e) => {
                      e.stopPropagation()
                      setDateExpiredNHSO('')
                      props.setDataAbout((value: any) => ({ ...value, dateExpiredAllBranchNHSO: '' }))
                    }}
                    helperText={dateExpiredNHSO ? '' : t(props.errorMessageSetting.DATE_EXPIRED_NHSO)}
                    //  disabled={voucherId !== 0}
                    disabledDatePast
                    language={i18n.language.toUpperCase() as any}
                  />
                </Box>
              </Grid>}
            </Grid>
            {props.dataABout?.useAllBranchesNHSO === '0' && <Box marginTop="16px" paddingLeft="32px">
              <TableCustom
                headCells={generateHeadCells('NHSO')}
                onSort={(sortByVal: string, sortTypeVal: string) => {
                  // setSortByVal(sortByVal)
                  // setSortTypeVal(sortTypeVal) 
                }}
                page={page}
                pageLimit={pageLimit}
                rowsData={props?.branchDefaultRegisterApps?.map((item: any, index: number) => {
                  return renderData(item, index, 'NHSO', erroeNHSO[index]?.DATE_EXPIRED)
                })
                }
                setPage={(e) => setPage(e)}
                setPageLimit={(e) => setPageLimit(e)}
                sortBy={'branchId'}
                sortType={'ASC'}
                rowCount={rowCount}
                hidePagination={true}
              />
            </Box>}
          </>}
        </Box>
      </Box>
      <Box>
        <Box marginX={'10px'}><InputCheckbox label={t('CLINIC_MANAGEMENT.FORM.EMAIL_ENABLE')} checked={props.dataABout?.openEmailNotification === '1'} onChange={() => props.setDataAbout((value: any) => ({ ...value, openEmailNotification: props.dataABout?.openEmailNotification === '1' ? '0' : '1' }))} /></Box>
      </Box>
      <Box marginX={'10px'}><InputCheckbox disabled label={t('CLINIC_MANAGEMENT.FORM.LINE_ENABLE')} checked={props.dataABout?.openLineNotification === '2'} onChange={() => props.setDataAbout((value: any) => ({ ...value, openLineNotification: props.dataABout?.openLineNotification === '1' ? '0' : '1' }))} /></Box>
      <Box marginX={'10px'} display="none"><InputCheckbox label={t('CLINIC_MANAGEMENT.FORM.SMS_ENABLE')} checked={props.dataABout?.openSmsNotification === '1'} onChange={() => props.setDataAbout((value: any) => ({ ...value, openSmsNotification: props.dataABout?.openSmsNotification === '1' ? '0' : '1' }))} /></Box>
      <Box className={`d-none`}>
        <Grid container spacing={2}>
          {
            <Grid item xs={12} sm={6} md={4} xl={3}>
              <BasicSelect
                name="add_on_app"
                label={t('CLINIC_MANAGEMENT.LABEL.APPLICATION')}
                selectId="sl-add-on-app"
                labelId="lb-add-on-app"
                value={enableApp === '0' ? 'FALSE' : 'TRUE'}
                style={{ fontSize: '16px' }}
                options={[
                  <MenuItem key="1" value="FALSE">
                    {t('CLINIC_MANAGEMENT.LABEL.CLOSE')}
                  </MenuItem>,
                  <MenuItem key="2" value="TRUE">
                    {t('CLINIC_MANAGEMENT.LABEL.OPEN')}
                  </MenuItem>
                ]}
                onchange={(e) => {
                  props.callbackEnableApp(e.target.value === "TRUE" ? "1" : "0")
                }}
              />
            </Grid>}
        </Grid>
        <Divider className="mx-0 my-4" sx={{ backgroundColor: 'transparent', opacity: 1, borderColor: `${colors.lightGray} !important` }} />
        <Box sx={{ paddingBottom: "16px" }}>
          <Typography sx={{ fontSize: '1.25rem', fontWeight: '500' }}>{t('CLINIC_MANAGEMENT.FORM.APPLICATION')}</Typography>
        </Box>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={3}>
            <Typography sx={{ fontWeight: 500, pl: 2 }}>
              {t('CLINIC_MANAGEMENT.FORM.NAME_BR')}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={3}>
            <Typography sx={{ fontWeight: 500 }}>
              {t('CLINIC_MANAGEMENT.FORM.AUTO_REGIS_APP')}
            </Typography>
          </Grid>
        </Grid>
        {branchDefaultRegisterApps?.map((val: any, index: any) => (
          <Grid container key={index} spacing={2} alignItems="center" sx={{ pt: 2 }}>
            <Grid item xs={12} sm={3}>
              <Typography sx={{ pl: 2 }}>
                {val.branchName}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={4}>
              <BasicSelect
                disabled={enableApp === '1' ? false : true}
                name={`auto_regis_${index}`}
                label=""
                selectId={`sl-auto-regis-${index}`}
                labelId={`lb-auto-regis-${index}`}
                value={val.isDefaultRegisApp === '0' ? 'FALSE' : 'TRUE'}
                style={{ fontSize: '16px' }}
                options={[
                  <MenuItem key="1" value="FALSE">
                    {t('CLINIC_MANAGEMENT.LABEL.CLOSE')}
                  </MenuItem>,
                  <MenuItem key="2" value="TRUE">
                    {t('CLINIC_MANAGEMENT.LABEL.OPEN')}
                  </MenuItem>
                ]}
                onchange={(e) => {
                  val.isDefaultRegisApp = e.target.value === "TRUE" ? "1" : "0"
                  props.callbackRegisterApps([...branchDefaultRegisterApps])
                }}
              />
            </Grid>
          </Grid>
        ))}
        <Box>
          <Divider className="mx-0 my-4" sx={{ backgroundColor: 'transparent', opacity: 1, borderColor: `${colors.lightGray} !important` }} />
          <Box sx={{ paddingBottom: "16px" }}>
            <Typography sx={{ fontSize: '1.25rem', fontWeight: '500' }}>
              {t('CLINIC_MANAGEMENT.FORM.WEBSITE_TITLE')}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box >
  )
}

